import '../App.css';
import PictureBanner from '../assets/img/bg-nos-cpc.jpg';
import Hero from '../components/Hero';
import { Helmet } from "react-helmet";

function CPC() {

  const hero = {
    banner: PictureBanner,
    title: 'Nos cadres de prescription compassionnels (CPC)',
    subtitle: 'Les cadres de prescription compassionnels',
    items: [
      {
        title: 'TOXINE BOTULINIQUE DE TYPE A',
        subtitle: 'Douleur Neuropathique',
        link: 'http://www.cpc-botox.com/'
      }
    ],
    noItems: 'Pas de CPC actuellement',
    breadcrumb: [
      {
        title: 'Vraie-Vie',
        link: '/'
      },
      {
        title: 'Nos CPC'
      }
    ]
  }

  return (
    <>
      <Helmet>
        <title>Nos cadres de prescription compassionnels | AbbVie Vraie Vie</title>
        <meta
          name="description"
          content="Portail ATU, RTU, Etudes"
        />
      </Helmet>
      <Hero 
        key={'hero-CPC'}
        banner={hero.banner}
        title={hero.title}
        subtitle={hero.subtitle}
        items={hero.items}
        noItems={hero.noItems}
        breadcrumb={hero.breadcrumb}
      />
      <p className='text-xxl'>
        Le Cadre de Prescription Compassionnelle vise des médicaments qui disposent déjà d'une AMM pour une ou plusieurs indications données, mais qui sont utilisés en dehors de ces indications thérapeutiques pour d'autres situations.
      </p>
      <div className='abbvie-container'>
        <div className="medium-container">
          <div className='flex1'>
            <h2>Il est établi par le directeur général de l'ANSM pour une <strong>durée de 3 ans renouvelable</strong> sous réserve :</h2>
          </div>
          <div className='flex1'>
            <ul>
              <li>D'un besoin thérapeutique</li>
              <li>D'une présomption de rapport bénéfice/risque favorable notamment issue de données scientifiques publiées d'efficacité et de tolérance.</li>
            </ul>
          </div>
        </div>
      </div>
      <p className='text-md'>
        AbbVie collabore étroitement avec l'ANSM pour le suivi des patients bénéficiant d'un CADRE DE PRESCRIPTION COMPASSIONNELLE selon les modalités fixées dans le Protocole d’Utilisation Thérapeutique et de Suivi des Patients (PUT-SP) le cas échéant.
        Le référentiel des cadres de prescription compassionnelle en cours est disponible sur le site de l'ANSM (https://ansm.sante.fr/documents/reference/referentiel-des-specialites-en-acces-derogatoire).
        Toute demande pour faire bénéficier un patient d'un CADRE DE PRESCRIPTION COMPASSIONNELLE en cours avec un médicament AbbVie se fait via le site «AbbVie Vraie Vie ».
      </p>
    </>
  )
}

export default CPC;
